export default [
  { value: 'Brick', label: 'Brick' },
  { value: 'Stucco', label: 'Stucco' },
  { value: 'Vinyl', label: 'Vinyl' },
  { value: 'Wood', label: 'Wood' },
];
